<template>
  <div>
    <div class="header">
      <router-link tag="a" to="/what-to-do">
        <span class="mobile-none">Request additional </span>insights
        <fa icon="chevron-right"></fa>
      </router-link>
    </div>
    <ActivityTable></ActivityTable>
  </div>
</template>

<script>
import ActivityTable from '../ActivityTable';

export default {
  components: {
    ActivityTable
  }
};
</script>

<style lang="scss" scoped>
.card /deep/ .ivu-table {
  th {
    background-color: $gray-light !important;
  }
}

.header {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  align-items: baseline;

  a {
    margin-bottom: 16px;
    @media screen and (max-width: 480px) {
      text-transform: capitalize;
    }
  }

  span.mobile-none {
    @media screen and (max-width: 480px) {
      display: none;
    }
  }
}

h3 {
  @media screen and (max-width: 485px) {
    font-size: 20px;
    max-width: 240px;
  }

  @media screen and (max-width: 370px) {
    max-width: 180px;
  }
}
</style>
